/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { UserSearch } from "containers/Customers/types/Customers";
import { FilterOptions } from "./types/AccessManagementTypes";

export const getCurrentGroupId = () => {
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split("/");

  return pathParts[pathParts.length - 1];
};

export const getBusinessUsage = (
  usageFilters: FilterOptions["usageFilters"],
): string => {
  if (usageFilters.business) return "true";

  if (usageFilters.personal) return "false";

  return "";
};

export const getChargeMode = (
  chargeModeFilters: FilterOptions["chargeModeFilters"],
): string => {
  if (chargeModeFilters.fast) return "1";

  if (chargeModeFilters.eco) return "2";

  if (chargeModeFilters.ecoPlus) return "3";

  if (chargeModeFilters.noneSelected) return "0";

  return "";
};

export const getGroupNameAndLocation = (
  groupId: string,
  users: UserSearch[],
): { groupName: string | null; locationId: string | null } => {
  let groupName = null;
  let locationId = null;

  users.some((user) => {
    if (user.mainAccessGroup.id === groupId) {
      groupName = user.mainAccessGroup.groupName;
      locationId = user.addressId;

      return true;
    }

    const additionalGroup = user.additionalAccessGroups.find(
      (group) => group.id === groupId,
    );

    if (additionalGroup) {
      groupName = additionalGroup.groupName;
      locationId = user.addressId;

      return true;
    }

    return false;
  });

  return { groupName, locationId };
};
